import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

import { useSystemsContextProvider } from 'features/systems/context/systems-provider';
import { SystemType } from 'features/systems/domain/models/system';
import DomipSystemDetailsContent from 'features/systems/domip/domip-system-details-content';
import IPUnitConfiguration from 'features/systems/ip-unit/ip-unit-configuration';
import IS32Configuration from 'features/systems/IS32/views/IS32-configuration';
import SystemOrganisation from 'features/systems/views/details/configuration-settings/system-organisation';
import styles from 'features/systems/views/details/system-configuration.module.scss';

const SystemConfiguration = (): React.JSX.Element => {
  const { t } = useTranslation('systems');

  const { systemsDetailsHook } = useSystemsContextProvider();

  const { watch } = useFormContext();

  const watchSystemType = watch('type');

  const isViewing = systemsDetailsHook.viewingMode === 'viewing';
  const hasSelectedType = SystemType.Unknown !== watchSystemType;

  if (!hasSelectedType) return <></>;

  return (
    <div className={`${styles.container} ${isViewing && styles.viewing}`}>
      <div className={styles.settingsItem}>
        <Typography variant="h5">{t('details.configuration.organisationUnitLabel')}</Typography>
        <div className={styles.settingsItemContent}>
          <SystemOrganisation />
        </div>
      </div>
      <Divider sx={{ width: '100%' }} />
      {systemsDetailsHook.selectedSystem?.type === SystemType.IS32 && <IS32Configuration />}
      {systemsDetailsHook.selectedSystem?.type === SystemType.IPUnit && <IPUnitConfiguration />}
      {systemsDetailsHook.selectedSystem?.type === SystemType.Domip && <DomipSystemDetailsContent />}
    </div>
  );
};

export default SystemConfiguration;
